<div class="kt-portlet">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Etkinlik Kategori Listesi
            </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
            <div class="kt-portlet__head-actions">
                <a routerLink="/event-categories/new" class="btn btn-success btn-pill btn-sm">
                    <i class="fa fa-plus marr10"></i>Yeni Ekle
                </a>

            </div>
        </div>
    </div>
    <div class="kt-portlet__body">
        <div class="kt-section">
            <div class="kt-section__content">

                <div class="kt-pagination  kt-pagination--brand">
                    <ul class="kt-pagination__links">
                    </ul>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Kategori ismi</th>
                                <th>Birden fazla başvuruya izin veriliyor mu?</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eventCategory of eventCategories;">
                                <td>{{eventCategory.name}}</td>
                                <td>{{isMultiple(eventCategory.isMultiple)}}</td>
                                <td>
                                    <button class="btn btn-success mr-2"
                                        [routerLink]="['/event-categories/detail/'+eventCategory.id]"><i
                                        class="fa fa-edit"></i>Düzenle</button>
                                    <button class="btn btn-danger mr-2" (click)="deleteEventCategory(eventCategory.id, eventCategory.name)"><i
                                            class="fa fa-trash"></i>Sil</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
